import { FileExclamationOutlined, FileDoneOutlined } from '@ant-design/icons';
import { Button, Select, Tabs } from 'antd';
import { useFMCSA, useFmcsaCount } from '../../../../Hooks/TT_ELD/FMCSA';
import { useState } from 'react';
import FMCSA_Table from './FMCSA_Table/FMCSA_Table';
import useRouteQuery from '../../../../Utils/useRouterQuery';
import { useTagQuerySync } from '../../../../Utils/useTagQuerySync';

const { Option } = Select;

const report_status = [
  { label: 'Needs review', value: 'needs_review' },
  { label: 'Checking', value: 'checking' },
];

const FMCSAReviewTab = ({ status, skip, setStatus, setSkip }: any) => {
  const { data, refetch, isLoading, isFetching } = useFMCSA(status, skip);
  const count = useFmcsaCount();

  const onChange = (query: any) => {
    setSkip(query.current);
  };

  const handleChange = (value: string) => {
    setStatus(value);
    setSkip(1);
  };

  const refresh = () => {
    refetch();
    count.refetch();
  };

  return (
    <div>
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Select
          value={status || 'all'}
          onChange={(value) => handleChange(value === 'all' ? '' : value)}
          style={{ width: 200 }}
        >
          <Option value="all">All Status</Option>
          {report_status.map((u) => (
            <Option key={u.value} value={u.value}>
              {u.label}
            </Option>
          ))}
        </Select>
        <Button size="large" onClick={refresh}>
          Refresh
        </Button>
      </span>
      <FMCSA_Table
        data={data?.data}
        onChange={onChange}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={refresh}
        status="needs_review"
        skip={skip}
      />
    </div>
  );
};

const FmcsacheckTab = ({ skip, setSkip }: any) => {
  const { data, refetch, isLoading, isFetching } = useFMCSA('checked', skip);
  const count = useFmcsaCount();

  const onChange = (query: any) => {
    setSkip(query.current);
  };

  const refresh = () => {
    refetch();
    count.refetch();
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <Button style={{ marginBottom: 6 }} size="large" onClick={refresh}>
          Refresh
        </Button>
      </div>
      <FMCSA_Table
        data={data?.data}
        onChange={onChange}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={refresh}
        status="checking"
        skip={skip}
      />
    </div>
  );
};

const Fmcsa = () => {
  const [tabKey, setTabKey] = useRouteQuery('1', 'tabKey', (v) => String(v));
  const [status, setStatus] = useRouteQuery('', 'status', (v) => String(v));
  const [skip, setSkip] = useState<number>(1);

  useTagQuerySync(
    { en_US: 'FMCSA', zh_CN: '' },
    'fmcsa',
    { tabKey, status, skip },
    { tabKey: setTabKey, status: setStatus, skip: setSkip },
  );

  const items = [
    {
      label: 'Unchecked',
      key: '1',
      children: (
        <FMCSAReviewTab status={status} skip={skip} setStatus={setStatus} setSkip={setSkip} />
      ),
      icon: <FileExclamationOutlined />,
    },
    {
      label: 'Checked',
      key: '2',
      children: <FmcsacheckTab skip={skip} setSkip={setSkip} />,
      icon: <FileDoneOutlined />,
    },
  ];

  return (
    <div className="mainPage">
      <Tabs activeKey={tabKey} onTabClick={setTabKey} items={items} />
    </div>
  );
};

export default Fmcsa;
